import { Column } from "components/Table/Table";
import { DATE_FORMAT_PRINT } from "config/constants";
import { JobTypeColor } from "config/status";
import { statusColorPrinter } from "constants/colors";
import useText from "constants/text";
import { SubTask, SubTaskType } from "generated/graphql";
import { useHupAdress } from "hooks/useCurrentUser";
import { DeliveryIcon, PickUpIcon } from "icons";
import moment from "moment";
import React from "react";
import StatusInfo from "ui/StatusInfo";

export const useJobColumnsRow = (): Column<Partial<SubTask>>[] => {
  const { text } = useText();
  const defaultAdress = useHupAdress();
  return [
    {
      title: `${text.all.task_type}`,
      field: "job_type",
      render: ({ subtask_type }) => (
        <div
          style={{
            color: JobTypeColor[subtask_type],
            display: "flex",
            justifyContent: "start",
            justifyItems: "start",
          }}
        >
          <div
            style={{
              marginTop: "auto",
              marginBottom: "auto",
              height: 35,
              width: 35,
              borderRadius: 12,
              background: subtask_type === SubTaskType.Pickup ? "#e3f8fa" : "#faecca",
              display: "flex",
              justifyContent: "center",
              justifyItems: "center",
            }}
          >
            <div
              style={{
                marginTop: "auto",
                marginBottom: "auto",
                display: "flex",
                justifyContent: "center",
                justifyItems: "center",
              }}
            >
              {subtask_type === SubTaskType.Pickup ? (
                <PickUpIcon height={18} width={18} />
              ) : (
                <DeliveryIcon height={18} width={18} />
              )}
            </div>
          </div>
          <div
            style={{
              marginTop: "auto",
              marginBottom: "auto",
              marginLeft: 15,
              textTransform: "capitalize",
            }}
          >
            {subtask_type === SubTaskType.Pickup ? `${text.all.pickup}` : `${text.all.delivery}`}
          </div>
        </div>
      ),
    },
    {
      title: `${text.all.address}`,
      field: "subtask_address",
      render: ({ subtask_address }) => (subtask_address ? subtask_address?.address : defaultAdress),
    },
    {
      title: `${text.all.date}`,
      field: "subtask_execution_date",
      render: ({ subtask_execution_date }) => moment(subtask_execution_date).format(DATE_FORMAT_PRINT),
    },
    {
      title: `${text.all.status}`,
      field: "job_status",
      render: ({ subtask_status }) => (
        <StatusInfo
          width="127px"
          color={statusColorPrinter({ status: subtask_status, type: "text" })}
          background={statusColorPrinter({ status: subtask_status, type: "bg" })}
          status={subtask_status?.replace(/_/g, " ")}
        />
      ),
    },
  ];
};
